// extracted by mini-css-extract-plugin
module.exports = {"form":"TextInput_form__26Df_","input":"TextInput_input__26L-B","label":"TextInput_label__z646u","contentName":"TextInput_contentName__339z_"};